import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IAppInvitation } from '../types/app-invitation.types';

interface AppInvitationState extends BaseDataReducerV2InitialState<IAppInvitation> {
  perPage: number;
  isModalOpen: boolean;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IAppInvitation, AppInvitationState>('app-invitation');

const appInvitationState: AppInvitationState = {
  ...initialState,
  perPage: 10,
  isModalOpen: false,
};

export const appInvitation = createSlice({
  name: 'appInvitation',
  initialState: appInvitationState,
  reducers: {
    setIsAppInvitationModalOpen(state, action: PayloadAction<boolean>) {
      state.isModalOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as AppInvitationState, action);
    });
  },
});
export const AppInvitationAC = AC;
export const onAppInvitationFilter = thunks.onFilter;
export const clearAppInvitationFilters = AC.clearFilters;
export const setAppInvitationCurrentPage = AC.setCurrentPage;

export const { setIsAppInvitationModalOpen } = appInvitation.actions;
